module.exports = __webpack_public_path__ + "static/Fabulous-logo-1-2041cd5dc4ce86434003765925653b0f.png";